import { ReactNode } from 'react';
import { JobsDataProvider } from '../../jobs/context/JobsContext';
import { QuoteDataProvider } from '../../quotes/context/QuotesContext';
import { ScheduleContext } from './ScheduleContext';

interface ScheduleDataProviderProps {
  children: ReactNode;
}

export function ScheduleDataProvider({ children }: ScheduleDataProviderProps) {
  return (
    <JobsDataProvider>
      <QuoteDataProvider>
        <ScheduleContext>
          {children}
        </ScheduleContext>
      </QuoteDataProvider>
    </JobsDataProvider>
  );
}